// Future App.js with routing
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import JobApplicantDashboard from './components/JobApplicantDashboard';
import Login from './components/Login';

function App() {
  return (
    <Router>
      <div className="App">
        <JobApplicantDashboard />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<JobApplicantDashboard />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;